<template>
  <div
    class="commerce-connector _rfp_mctb_popup_01_ rfp-mctb-common-buynow-header"
  >
    <button
      ref="buttonCommerce"
      class="commerce-connector__button _rfp_mctb_popup_02_ rfp-mctb-common-buynow rfp-mctb-product-list-card-buttom"
      data-qa="cm-cta"
      @click="onCtaClick"
    >
      <slot></slot>
    </button>
    <div class="commerce-connector__popup" v-if="show">
      <div class="modal" ref="overlay">
        <div class="modal__content">
          <button class="modal__close" @click="toggle()">
            <svg aria-hidden="true" class="icon">
              <use
                xlink:href="#close"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              ></use>
            </svg>
          </button>
          <div>
            <div class="commerce-connector__popup__heading">
              <div class="commerce-connector__image" v-if="mediagalleryImage">
                <img :src="mediagalleryImage" :alt="productName" />
              </div>
              <div class="commerce-connector__product">
                <div class="commerce-connector__product-label" v-if="label">
                  <span>{{ label }}</span>
                </div>
                <div class="commerce-connector__product-range" v-if="rangeName">
                  {{ rangeName }}
                </div>
                <div
                  class="commerce-connector__product-title" v-titleSup="productName"
                  v-if="productName"
                >
                </div>
                <product-card-rating v-if="productRatings.enabled"
                  :rating="productRatings"
                ></product-card-rating>
              </div>
            </div>
            <div
              class="commerce-connector__popup__retailers"
              :class="[
                retailersListToDisplay.length == 0 ? 'noretailer' : 'retailer',
              ]"
            >
              <ul
                class="commerce-connector__retailerslist"
                v-if="retailersListToDisplay.length >= 1"
                :class="[
                  retailersListToDisplay.length == 4 ? 'removescroll' : '',
                ]"
              >
                <template>
                  <li
                    class="commerce-connector__retailerslist-item"
                    v-for="retailer in retailersListToDisplay"
                    :key="retailer.id"
                  >
                    <img :src="retailer.logo" :alt="retailer.title" />
                    <a
                      :href="retailer.link"
                      target="_blank"
                      class="_rfp_mctb_popup_02_ rfp-mctb-common-buynow rfp-mctb-product-list-card-buttom"
                      @click="sendRetailerTagging(retailer)"
                      >{{ retailerBuyCtaText }}</a
                    >
                  </li>
                </template>
              </ul>
              <div v-else>{{ noRetailersLabel }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pdp-commerce-cta',
  components: {},
  data() {
    return {
      retailersList: [],
      isRequestFailed: false,
      errorMessage: null,
      tokenCounter: 0,
      isShopsUnavailable: false,
      activeShadeEAN: '',
      show: false,
      mediagalleryImage: '',
      scrollPosition: 0,
    };
  },
  props: {
    baseUrlFetchRetailers: { type: String, default: '' },
    retailerBuyCtaText: { type: String, default: '' },
    noRetailersLabel: { type: String, default: '' },
    choseRetailerTagging: { type: Object, default: () => {} },
    productImage: { type: String, default: '' },
    productName: { type: String, default: '' },
    rangeName: { type: String, default: '' },
    label: { type: String, default: '' },
    productRatings: { type: Object, default: () => {} },
    productEan: { type: String, default: '' },
  },
  computed: {
    retailersListToDisplay() {
      return !this.isShopsUnavailable
        ? this.mapToRetailerCards(this.retailersList)
        : [];
    },
  },
  mounted() {
    eventBus.$on('shade::selected', this.collectShadeEan);
    document.addEventListener('keydown', this.onEscKeydown);
  },
  beforeDestroy() {
    document.remodeEventListener('keydown', this.onEscKeydown);
  },
  methods: {
    onEscKeydown(event) {
      if (event.key === 'Escape') {
        this.toggle();
      }
    },
    toggle() {
      this.show = !this.show;
      const body = document.querySelector('body');
      body?.classList.toggle('navOpen', this.show);

      if (this.show) {
        this.scrollPosition =
          window.pageYOffset || document.documentElement.scrollTop;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollPosition}px`;
      } else {
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, this.scrollPosition);
      }
    },
    async onCtaClick() {
      const ean = this.activeShadeEAN || this.productEan;
      try {
        const retailersUrl = `${window.location.protocol}//${window.location.host}${this.baseUrlFetchRetailers}?productEanOrUpc=${ean}`;
        const response = await fetch(retailersUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        });
        if (response) {
          const retailers = await response.json();
          this.retailersList =
            retailers && retailers.shops ? retailers.shops : [];
          this.tokenCounter =
            retailers && retailers.availableShopsCount
              ? retailers.availableShopsCount
              : 0;
          this.isRequestFailed =
            retailers && retailers.requestFailed
              ? retailers.requestFailed
              : false;
          this.errorMessage =
            retailers && retailers.errorMessage ? retailers.errorMessage : null;
          this.isShopsUnavailable = retailers && retailers.shopsUnavailable;
          let parentEle = document.getElementsByClassName('media-gallery');
          if (parentEle != null) {
            let sliderItem = parentEle[0].querySelectorAll('.slider__item');
            let img = sliderItem[0].querySelector('img');
            if (img != null) {
              this.mediagalleryImage = img.src;
            }
          }
          this.toggle();
        } else {
          console.error('Promise resolved but HTTP status failed');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    },
    mapToRetailerCards(shops = []) {
      return shops.map((shop) => {
        return {
          id: shop.id,
          logo: shop.logo,
          title: shop.title,
          link: shop.offerInfo.Offers[0].Deeplink,
        };
      });
    },
    sendRetailerTagging(retailerData) {
      const data = { ...this.choseRetailerTagging };
      data.store_name = `${retailerData.title.toLowerCase()}`;
      window.dataLayer.push(data);
    },
    collectShadeEan(data) {
      this.activeShadeEAN = data;
    },
  },
};
</script>
